import { useCallback, useState } from "react";

export const useErrorHandler = () => {
  const [error, setError] = useState<string | null>(null);

  const handleError = useCallback(
    (
      error: string | Error | null,
      options?: {
        persist?: boolean;
        context?: string;
        logToConsole?: boolean;
      }
    ) => {
      const { persist = false, context, logToConsole = true } = options || {};

      const errorMessage = error instanceof Error ? error.message : error;

      setError(errorMessage);

      if (logToConsole && errorMessage) {
        console.error(context ? `[${context}] ${errorMessage}` : errorMessage);
      }

      if (!persist && errorMessage) {
        setTimeout(() => setError(null), 5000);
      }

      return errorMessage;
    },
    []
  );

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    error,
    handleError,
    clearError,
  };
};
